// -- == //
import SecundButton from 'components/form/buttons/secundButton';

// import { useActions } from "common/hooks/useActions";
import MiniPopUp from 'components/modal/miniPopUp';
import PanelBoxLayout from 'components/layout/panelBox';

import { Formik } from 'formik';
import Gap from 'components/gap';
import PrimaryButton from 'components/form/buttons/primaryButton';
import { SetStateAction } from 'react';

import * as S from './styles';
import * as T from 'common/types';
import DropDown from 'components/form/dropDown';
import OutlineButton from 'components/form/buttons/outLineButton';

interface IProps {
  setFilter: SetStateAction<any>;
  setPage: SetStateAction<any>;
  filter: any;
}

export default function TicketFilterPopup({ setFilter, filter, setPage }: IProps) {
  return (
    <S.Content>
      <MiniPopUp
        popUpStyle={{ width: 245, padding: '0' }}
        buttonNode={
          <SecundButton
            hasIcon={true}
            icon="/icons/stroke/filter.svg"
            iconStyle={{ background: 'none' }}
            style={{ background: '#8A93AC' }}
            colorIcon="var(--white)"
          >
            Filters
          </SecundButton>
        }
      >
        <PanelBoxLayout
          style={{ padding: 15 }}
          titleStyle={{ color: '#2D3748', fontSize: 14 }}
          title="Filters"
          icon="/icons/stroke/filter.svg"
        >
          <Formik
            initialValues={{
              state: ''
            }}
            // validationSchema={ValidationLogin}
            onSubmit={(values, { setSubmitting }) => {
              setFilter({ ...filter, ...values });
              setSubmitting(false);
              setPage(1);
            }}
          >
            {({
              values,
              errors,
              touched,
              // handleChange,
              handleSubmit,
              // isSubmitting,
              setValues,
              resetForm
            }) => (
              <>
                <DropDown
                  label="State"
                  list={[
                    { id: '1', title: 'New' },
                    { id: '2', title: 'In Progress' },
                    { id: '3', title: 'Closed' },
                    { id: '5', title: 'On Hold' },
                    { id: '7', title: 'Canceled By Requester' },
                    { id: '4', title: 'Canceled By Approver' }
                  ]}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      state: e.id as any
                    });
                  }}
                  placeholder="Select state"
                  message={touched.state && (errors.state as any)}
                  error={errors.state as unknown as boolean}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                {/* <Gap size="20px" />

                <DropDown
                  label="Categories"
                  list={ticketCategory}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      categoryId: e.id as any
                    });
                  }}
                  placeholder="Select Categories"
                  message={touched.categoryId && (errors.categoryId as any)}
                  error={errors.categoryId as unknown as boolean}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                /> */}

                <Gap size="20px" />

                <PrimaryButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={handleSubmit}
                  // disabled={isSubmitting}
                >
                  Filter
                </PrimaryButton>
                <Gap size="15px" />
                <OutlineButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={() => {
                    resetForm();
                    setPage(1);
                    setFilter({ state: '' });
                  }}
                  // disabled={isSubmitting}
                >
                  Reset
                </OutlineButton>
              </>
            )}
          </Formik>
        </PanelBoxLayout>
      </MiniPopUp>
    </S.Content>
  );
}
